import { Product } from "types/index";
import { ProductLink } from "./LinkUtils";

export const productLinkWithDetails = (product: Pick<Product, "id" | "name"> | undefined | null, details: string) => {
	if (!product && !details) {
		return undefined;
	} else if (details && product) {
		return <span><ProductLink product={product} /> - {details}</span>;
	} else if (product && !details) {
		return <span><ProductLink product={product} /></span>;
	} else {
		return details;
	}
};
